import { FC } from 'react'

import { RadioGroup } from 'ui/components'
import { TextareaInput } from 'ui/components/InputV2'
import { Select } from 'ui/components/Select'
import { Col, Col2x, FormRow } from 'ui/themes/globalStyles'

import { MainText, SecondText } from '../../style'
import { ReviewTheCashActivityProps } from '../ReviewTheCashActivity/ReviewTheCashActivityProps'

export const ComparePriorAndCurrentPercentage: FC<ReviewTheCashActivityProps> = ({ Field }) => (
  <>
    <FormRow>
      <Col2x>
        <MainText>
          The business receives substantially more revenue than may reasonably be expected given the relevant
          limitations imposed by the state in which it operates.
        </MainText>
      </Col2x>
    </FormRow>
    <FormRow>
      <Col2x>
        <MainText>
          The business makes cash deposits or withdrawals over a short period of time that are excessive related to
          local competitors or the expected activity of the business.
        </MainText>
      </Col2x>
    </FormRow>
    <FormRow>
      <Col>
        <SecondText>
          Compare prior and current year’s activity for a 25% variance. If not within the variance, contact customer to
          understand differences. (Fed approved 11/07/17)
        </SecondText>
      </Col>
      <Col>
        <Field
          name="comparePriorAndCurrentPercentageRedFlag"
          input={RadioGroup}
          inputProps={{
            data: [
              {
                label: 'Yes',
                value: 'yes'
              },
              {
                label: 'No',
                value: 'no'
              }
            ]
          }}
        />
      </Col>
    </FormRow>
    <FormRow>
      <Col>
        <Field
          name="comparePriorAndCurrentPercentageVariance"
          label="Is activity within variance?"
          input={Select}
          inputProps={{
            data: [
              {
                label: 'All activity in Variance',
                value: 'All activity in Variance'
              },
              {
                label: 'See validated Variance and/or Annual Questions',
                value: 'See validated Variance and/or Annual Questions'
              },
              {
                label: 'New Account - No historical data',
                value: 'New Account'
              },
              {
                label: 'Other - See Comments',
                value: 'other'
              }
            ]
          }}
        />
      </Col>
    </FormRow>
    <FormRow>
      <Col2x>
        <Field
          name="comparePriorAndCurrentPercentageComments"
          label="Comments"
          input={TextareaInput}
          inputProps={{
            maxLength: 5000
          }}
        />
      </Col2x>
    </FormRow>
  </>
)
